import { NgModule } from '@angular/core';
import { TagifyComponent } from './tagify.component';

@NgModule({
  imports: [TagifyComponent],
  exports: [TagifyComponent],
})
export class TagifyModule {}
